import React from 'react';
// helpers/constants
import * as G from '../../../../helpers';
// ui
import { Flex } from '../../../../ui';
// feature navbar-menu
import { ReleaseVersionLink } from './ui';
//////////////////////////////////////////////////

const releasesUrl = 'https://www.amousinternational.com/updates';

const VersionRelease = ({
  iconsColor,
}) => (
  <Flex
    mr={10}
    p='4px 20px'
    color={iconsColor}
    justifyContent='flex-end'
    borderBottomRightRadius={25}
  >
    <ReleaseVersionLink
      target='_blank'
      withHover={true}
      href={releasesUrl}
    >
      {G.getWindowLocale('titles:releases', 'Releases')}
    </ReleaseVersionLink>
  </Flex>
);

export default VersionRelease;
